import { useMemo } from 'react';

import useServiceCategoriesQuery from '@/modules/employer/queries/useServiceCategories.query';
import { getFormattedRenewalSetupData } from '@/modules/Renewals/RenewalSetup/utils';

import { Renewal, RenewalDto } from '../renewals.types';

export const useFormattedRenewals = (data?: RenewalDto[]): Renewal[] => {
  const { list: serviceCategories } = useServiceCategoriesQuery();

  return useMemo(() => {
    if (!data) return [];

    return data.map((renewalDto) => getFormattedRenewalSetupData(renewalDto, serviceCategories)) as Renewal[];
  }, [data, serviceCategories]);
};
